<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <i class="fas fas-align-justify"></i>
          Quote
        </div>
        <div class="card-body">
          <div class="row" *ngIf="quote?.plans?.length < 1">
            <div class="col text-center">
              <h3 type="text-warning mb-3">
                This quote is awaiting a survery
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <labeled-display
                [name]="'Contract number'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.contractNumber"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Status'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.status"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Contract Type'"
                [class]="'form-control'"
                [value]="quote?.quotePayeeTypeId">
              </labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Assigned To'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="(quote?.createdByUser?.firstName ?? '') + ' ' + (quote?.createdByUser?.lastName ?? '')"></labeled-display>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col">
              <labeled-display
                [name]="'Plot'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.plot"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Park'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.park"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'PO Number'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.purchaseOrderNumber"></labeled-display>
            </div>
          </div>
          <div class="row">
            <!--              <div class="col-4">-->
            <!--                <labeled-display-->
            <!--                  [routerLink]="['/customers/' + quote?.customer?.id]"-->
            <!--                  [name]="'Customer'"-->
            <!--                  [type]="'text'"-->
            <!--                  [class]="'form-control'"-->
            <!--                  [value]="quote?.customer?.companyName ?? '' + ' - ' + quote?.customer?.invoiceName ?? ''"></labeled-display>-->
            <!--              </div>-->
            <div class="col-4">
              <labeled-display
                [name]="'Created Date'"
                [type]="'text'"
                [value]="quote?.dateCreated | date: 'dd/MM/yy'"
                [class]="'form-control'"></labeled-display>
            </div>
            <div class="col-4">
              <labeled-display
                [name]="!!quote?.dateFitted ? 'Fitted Date' : 'Fitting Date'"
                [type]="'text'"
                [value]="(quote?.dateFitted || quote?.fittingDate || '') | date: 'dd/MM/yy'"
                [class]="'form-control'"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'On Hold Status'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.quoteOnHoldStatus?.name"></labeled-display>
            </div>
          </div>
          <div class="row" *ngIf="!quote?.fleetwork">
            <div class="col">
              <labeled-display
                [name]="'Groundworks'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.groundWorks"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Clean Cost'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.cleanCost"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Uplift'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.uplift"></labeled-display>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <labeled-display
                [name]="'Comments'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.comments"></labeled-display>
            </div>
          </div>
          <hr *ngIf="quote?.fitrite365QuoteDetails != null">
          <div class="row" *ngIf="quote?.fitrite365QuoteDetails != null">
            <div class="col-12">
              <h4 class="float-left">Fitrite365 Details</h4>
            </div>
          </div>
          <div class="row" *ngIf="quote?.fitrite365QuoteDetails?.quoteType == 'TemplateQuote'">
            <div class="col">
              <labeled-display
                [name]="'Template Name'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="'(Templated)' + ' ' + templateName"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Deck Board Colour'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.deckBoardColour"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Balustrade Board Colour'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.balustradeColour"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Preliminary Customer Price'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.planTemplateCost | currency : 'GBP'"></labeled-display>
            </div>
          </div>
          <div class="row" *ngIf="quote?.fitrite365QuoteDetails?.quoteType == 'BespokeQuote'">
            <div class="row">
              <div class="col-auto">
                <img
                  src="{{templateUrl}}"
                  class="thumbnail-preview"
                  (click)="openFullscreen(templateUrl)">
              </div>
              <div class="col-auto">
                <img
                  src="{{topdownTemplateUrl}}"
                  class="thumbnail-preview"
                  (click)="openFullscreen(topdownTemplateUrl)">
              </div>
            </div>
            <div class="fullscreen-overlay" *ngIf="isFullscreen" (click)="closeFullscreen()">
              <img src="{{fullscreenUrl}}">
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col">
                  <labeled-display
                    [name]="'Template Name'"
                    [type]="'text'"
                    [class]="'form-control'"
                    [value]="'(Bespoke)' + ' ' + quote?.fitrite365QuoteDetails?.planTemplateName"></labeled-display>
                </div>
                <div class="col">
                  <labeled-display
                    [name]="'Deck Board Colour'"
                    [type]="'text'"
                    [class]="'form-control'"
                    [value]="quote?.fitrite365QuoteDetails?.deckBoardColour"></labeled-display>
                </div>
                <div class="col">
                  <labeled-display
                    [name]="'Balustrade Board Colour'"
                    [type]="'text'"
                    [class]="'form-control'"
                    [value]="quote?.fitrite365QuoteDetails?.balustradeColour"></labeled-display>
                </div>
                <div class="col">
                  <labeled-display
                    [name]="'Preliminary Price'"
                    [type]="'text'"
                    [class]="'form-control'"
                    [value]="quote?.fitrite365QuoteDetails?.planTemplateCost | currency : 'GBP'"></labeled-display>
                </div>
              </div>
            </div>
            <div class="row">
              <ng-container *ngFor="let m of quote?.fitrite365QuoteMeasurements">
                <div class="col-2">
                  <labeled-display
                    [name]="'Measurement' + ' ' + m.label"
                    [type]="'number'"
                    [class]="'form-control'"
                    [value]="m.measurement"></labeled-display>
                </div>
                <div class="col-auto d-flex align-self-end">
                  <div class="vertical-divider"></div>
                </div>
              </ng-container>
              <div class="col-2">
                <labeled-display
                  [name]="'Deck Skirted'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="quote?.fitrite365QuoteDetails?.deckSkirted ? 'Yes' : 'No'"></labeled-display>
              </div>
              <div class="col-auto d-flex align-self-end">
                <div class="vertical-divider"></div>
              </div>
              <div class="col-2">
                <labeled-display
                  [name]="'Caravan Skirted'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="quote?.fitrite365QuoteDetails?.caravanSkirted ? 'Yes' : 'No'"></labeled-display>
              </div>
              <div class="col-auto d-flex align-self-end">
                <div class="vertical-divider"></div>
              </div>
              <div class="col-2">
                <labeled-display
                  [name]="'Caravan Height (ft)'"
                  [type]="'number'"
                  [class]="'form-control'"
                  [value]="quote?.fitrite365QuoteDetails?.caravanHeight"></labeled-display>
              </div>
              <div class="col-auto d-flex align-self-end">
                <div class="vertical-divider"></div>
              </div>
              <div class="col-2">
                <labeled-display
                  [name]="'Number Of Hatches'"
                  [type]="'number'"
                  [class]="'form-control'"
                  [value]="quote?.fitrite365QuoteDetails?.numberOfHatches"></labeled-display>
              </div>
              <div class="col-auto d-flex align-self-end">
                <div class="vertical-divider"></div>
              </div>
              <div class="col-2">
                <labeled-display
                  [name]="'Number Of Gates'"
                  [type]="'number'"
                  [class]="'form-control'"
                  [value]="quote?.fitrite365QuoteDetails?.numberOfGates"></labeled-display>
              </div>
              <div class="col-auto d-flex align-self-end">
                <div class="vertical-divider"></div>
              </div>
              <div class="col-2">
                <labeled-display
                  [name]="'Number Of Step Sets'"
                  [type]="'number'"
                  [class]="'form-control'"
                  [value]="quote?.fitrite365QuoteDetails?.numberOfStepSets"></labeled-display>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="quote?.fitrite365QuoteDetails?.quoteType == 'RemoveAndRefit'">
            <div class="col">
              <labeled-display
                [name]="'Quote Type'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.quoteType"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Current Plot'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.currentPlot"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Destination Plot'"
                [type]="'text'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.destinationPlot"></labeled-display>
            </div>
            <div class="col">
              <labeled-display
                [name]="'Original Plan Square Footage'"
                [type]="'number'"
                [class]="'form-control'"
                [value]="quote?.fitrite365QuoteDetails?.originalPlanSquareFootage"></labeled-display>
            </div>
          </div>
          <hr>
          <div class="row">
            <h4 class="float-left">Plans</h4>
            <table class="table table-sm">
              <thead>
              <tr>
                <th>Name</th>
                <!--                <th>Template</th>-->
                <th>Sq Ft</th>
                <th>Status</th>
                <th>Last Updated</th>
                <th>Park Price (Net)</th>
                <th>Req Park Price (Net)</th>
                <th>Customer Price (Gross)</th>
                <th>Req Customer Price (Gross)</th>
                <th>Override Details</th>
                <th>Action</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let plan of quote?.plans">
                <td>
                  {{ plan?.name }}
                  <span *ngIf="plan.isFinalPlan" class="ml-2 badge badge-info">Final Plan</span>
                </td>
                <!--                <td>{{ plan.planTemplate?.description ?? "Bespoke" }}</td>-->
                <td>{{ plan.planSquareFootage }}</td>
                <td>{{ plan.status }}</td>
                <td>{{ plan.dateUpdated | date : 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ plan.parkPriceOverride || plan.parkPrice | currency : 'GBP' }}</td>
                <td class="text-danger">{{ plan?.requestedParkPriceOverride | currency : 'GBP' }}</td>
                <td>{{ plan.customerPriceOverride * 1.2 || plan.customerPrice * 1.2 | currency : 'GBP' }}</td>
                <td class="text-danger">{{ plan?.requestedCustomerPriceOverride * 1.2 || null | currency : 'GBP' }}</td>
                <td></td>
                <td>
                  <a class="btn btn-primary"
                     [routerLink]="['/quotes/viewplanimage/', plan.id]">View</a>
                </td>
                <td class="text center pt-3">
                  <h6 *ngIf="plan.isFinalPlan">
                    Final Plan
                  </h6>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
